<template>
  <main class="c-section c-section--panel-membership py-2">
    <h1 class="fs-21 w-bold darks mb-2">Mis membresía</h1>
    <p class="mb-4">Desde aquí podrás administrar o cambiar tu suscripción.</p>

    <div class="c-membership-grid">
      <div class="c-membership-grid__item">
        <div class="bg-white p-3 p-lg-4 br--small">
          <h2 class="fs-18 w-bold darks mb-3"><i class="iconf-king"></i> Membresia activa</h2>
          <div class="c-cash p-3 mb-2 ax-shadow ax-shadow--medium" :class="{ 'py-4' : isPremium }">
            <p v-if="!isPremium" class="mb-0 dark-gray w-medium">
              No cuentas con una membresía activa
            </p>
            <div v-else class="text-center">
              <h3 class="fs-18 w-bold mb-1">
                Arcux Premium - {{ membershipPlanName }}
                <span v-if="isTrialPremium" class="d-block fs-16 dark-gray w-sbold mt-1">
                  (Periodo de prueba)
                </span>
              </h3>
              <p
                v-if="membershipAmountRevenue"
                class="third-color fs-25 w-bold mb-0">
                {{ membershipAmountRevenue }}
              </p>

              <p class="mb-0 fs-14 dark-gray w-medium">{{ membershipDescription }}</p>
            </div>
          </div>

          <a
            v-if="!hasSubscriptionProvider && userCanRenew"
            href="/planes"
            class="c-button c-button--primary-ghost d-block text-center mt-4">
            Renovar membresía
          </a>

          <a
            v-if="!hasSubscriptionProvider && (isNormalUser || isTrialPremium)"
            :href="arcux.project.plans_link"
            class="c-button c-button--primary d-block text-center mt-4"
            target="_blank"
          >
            <i class="iconf-king me-1"></i>
            Comprar una membresía
          </a>

          <div v-if="isPremium && membership.expired_date" class="mt-4">
            <p v-if="membership.next" class="mb-0">
              Tu membresía se renovará automaticamente el
              <span class="w-bold">{{ membership.next.payment_date }}</span>
              <button class="c-link c-link--primary c-tooltip-toggle" >
                <i class="iconf-info"></i>
              </button>
            </p>
            <p v-else class="mb-0">
              Tu membresía vencerá el
              <span class="w-bold">{{ membership.expired_date.date }}</span>
            </p>
          </div>

          <button
            v-if="membership.next"
            @click="cancelDialog.switcher = true"
            class="c-link c-link--gray fs-14 mt-3"
          >
            Cancelar renovación automática
          </button>

          <div v-if="!hasSubscriptionProvider" class="mt-4">
            <h2 class="fs-18 w-bold darks mb-3"><i class="iconf-dollar"></i> Métodos de pago</h2>
            <p v-if="isLoadingPaymentMethods" class="">Cargando...</p>
            <ul v-else-if="paymentMethods.length" class="c-card-methods ul-reset">
              <li v-for="method of paymentMethods" :key="method.id">
                <div class="c-card-method p-3 p-lg-4">
                  <div class="row no-gutters">
                    <div class="col col-2">
                      <figure>
                        <img :src="getMethodLogo(method.brand)" class="w-100 of--contain" alt="">
                      </figure>
                    </div>
                    <div class="col col-10 pl-3">
                      <p class="w-sbold fs-14 mb-1">{{ getMethodSummary(method) }}</p>
                      <button
                        @click="openPaymentMethodDialog(method)"
                        class="c-card-method__delete"
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <p v-else>Sin metodos guardados</p>
          </div>
        </div>
      </div>
      <div class="c-membership-grid__item">
        <div class="bg-white p-3 p-lg-4 br--small">
          <h2 class="fs-18 w-bold darks mb-3"><i class="iconf-warranty"></i> Garantía</h2>
          <p v-if="membershipWarranty" class="mb-0 w-medium" v-html="membershipWarranty"></p>
          <p v-else class="mb-0 dark-gray">Sin garantia</p>
          <button
            v-if="isMembershipWarranty"
            @click="refundDialog.switcher = true"
            class="c-link c-link--gray fs-14 mt-2"
          >
            Solicitar reembolso
          </button>
        </div>
      </div>
    </div>

    <Dialog :data="cancelDialog">
      <template v-slot:body>
        <div class="c-form c-form--ghost mt-4">
          <p class="mb-2 darks w-medium">
            Detalla tu motivo <span class="dark-gray">(opcional)</span>
          </p>
          <select v-model="cancel.reason" class="c-form__select w-100">
            <option value="" disabled>Selecciona un motivo</option>
            <option value="No me gustaron los cursos">No me gustaron los cursos</option>
            <option value="No dispongo de dinero ahora">No dispongo de dinero ahora</option>
            <option value="Considero que el costo es muy elevado">
              Considero que el costo es muy elevado
            </option>
            <option value="No necesito la membresía en este momento">
              No necesito la membresía en este momento
            </option>
            <option value="No recibo ayuda con las dudas de mis cursos">
              No recibo ayuda con las dudas de mis cursos
            </option>
            <option value="other">Otro</option>
          </select>
          <textarea
            v-if="cancel.reason == 'other'"
            v-model="cancel.description.value"
            class="c-form__textarea w-100 mt-3"
            placeholder="Lo que pienso es que..."
            rows="3"></textarea>
          <span
            v-if="(cancel.reason == 'other') && isWrongField('description')"
            class="c-form__error">
            Texto demaisado corto o vacío
          </span>
        </div>
      </template>

      <template v-slot:navigation>
          <button
            @click="cancelDialog.switcher = false"
            class="c-button c-button--empty c-button--empty-white me-3">
            Cerrar
          </button>
          <button
            @click="deleteSubscriptionHandler()"
            class="c-button c-button--alerts"
            :disabled="cancel.isLoading"
            :class="{ 'loading' : cancel.isLoading }"
          >
            {{ (cancel.isLoading) ? 'Confirmando...' : 'Confirmar' }}
            <img
              class="c-button__spinner"
              src="../../assets/images/animations/spinner-white.png"
              alt="loading" />
          </button>
      </template>
    </Dialog>

    <Dialog :data="paymentMethodDialog">
      <template v-slot:navigation>
          <button
            @click="paymentMethodDialog.switcher = false"
            class="c-button c-button--empty c-button--empty-white">
            Cancelar
          </button>
          <button
            v-if="userCanDeleteCards"
            @click="deletePaymentMethodHandler()"
            class="c-button c-button--alerts ml-3"
            :disabled="method.isDeletingPaymentMethod"
            :class="{ 'loading' : method.isDeletingPaymentMethod }"
          >
            {{ (method.isDeletingPaymentMethod) ? 'Eliminando...' : 'Eliminar' }}
            <img
              class="c-button__spinner"
              src="../../assets/images/animations/spinner-white.png"
              alt="loading" />
          </button>
      </template>
    </Dialog>

    <Dialog :data="refundDialog">
      <template v-slot:body>
        <div class="mt-3">
          <p class="mb-3 w-medium">
            Lamentamos muchos que decidas tomar esta desición,
            agradecemos enormemente tu tiempo con nosotros.
          </p>
          <h4 class="mb-3 w-sbold fs-16 darks">Pasos que debes seguir</h4>

          <ul
            v-if="hasSubscriptionProvider && hasSubscriptionProvider === 'stripe'"
            class="c-steps"
          >
            <li data-number="1" class="c-steps__item">
              Enviar un correo a nuestro canal de soporte
              (<span class="w-bold">{{arcux.project.support_refound_email}}</span>)
              indicando tu email y la razón del reembolso
            </li>
          </ul>
          <ul v-else class="c-steps">
            <li data-number="1" class="c-steps__item">
              Abrir el formulario de solicitud del reembolso
              <a :href="arcux.project.refund" target="_blank" class="c-link c-link--primary">
                Click aqui
              </a>
            </li>

            <li data-number="2" class="c-steps__item">
              <p class="mb-2">
                Copiar y pegar el <span class="w-sbold">código de transacción</span>
              </p>
              <span class="bg-light-gray p-2 px-3 w-medium d-block br--small">
                {{ (membership.order) ? membership.order.transaction : 'XXX' }}
              </span>
            </li>

            <li data-number="3" class="c-steps__item">
              <p class="mb-2">
                Copiar y pegar el <span class="w-sbold">email de compra</span>
              </p>
              <span class="bg-light-gray p-2 px-3 w-medium d-block br--small">
                {{ (membership.order) ? membership.order.email : 'xxx@yy.com' }}
              </span>
            </li>
          </ul>
        </div>
      </template>

      <template v-slot:navigation>
          <button
            @click="refundDialog.switcher = false"
            class="c-button c-button--empty c-button--empty-white me-3">
            Cerrar
          </button>
      </template>
    </Dialog>
  </main>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

import tippy from 'tippy.js';

import Dialog from '../../components/ui/Dialog.vue';

export default {
  data() {
    return {
      arcux: {...window.arcux},
      user: null,

      membership: {
        remaining_days: '-',
      },

      paymentMethods: [],
      isLoadingPaymentMethods: false,
      isLoadingMembership: false,

      cancelDialog: {
        switcher: false,
        title: '¿Estas seguro de cancelar tu renovación automática?',
        body: '',
      },
      refundDialog: {
        switcher: false,
        title: 'Solicitar un reembolso',
        body: '',
      },
      paymentMethodDialog: {
        switcher: false,
        icon: 'iconf-trash-outlined',
        body: '',
      },

      cancel: {
        try: false,
        sent: false,
        isLoading: false,

        reason: '',
        description: {
          value: '',
          isValid: false,
        },
      },

      method: {
        selected: null,
        isDeletingPaymentMethod: false,
      },
    }
  },
  components: {
    Dialog,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    isNormalUser: function() {
      return (this.userData.roles.includes('student')) ? true : false;
    },
    isTrialPremium: function() {
      return (this.isPremium && this.membership.plan_name && this.membership.plan_name.toLowerCase().includes('trial'))
        ? true
        : false;
    },
    isPremium: function() {
      return (this.userData.membership) ? true : false;
    },

    membershipPlanName: function() {
      if (this.isLoadingMembership) {
        return 'Plan xx';
      } else {
        return (this.membership.plan_name) ? this.membership.plan_name : '';
      }
    },
    membershipDescription: function() {
      if (this.isTrialPremium) {
        return (this.membership.next && this.membership.next.price && this.membership.next.price.amount)
          ? `Termina en ${ this.membership.remaining_days } días, luego ${ Number(this.membership.next.price.amount).toFixed(2) }/${ this.membershipTimeRevenue }`
          : 'XX';
      } else if (this.isPremium) {
        return `Termina en ${ this.membership.remaining_days } días`;
      } else {
        return 'XX';
      }
    },
    membershipTimeRevenue: function() {
      return (this.isPremium && this.membership.next && this.membership.plan_name)
        ? ( this.membership.plan_name.toLowerCase().includes('anual') ) ? 'año' : 'mes'
        : 'xx';
    },
    membershipAmountRevenue: function() {
      if (this.isLoadingMembership) {
        return '$ 00.00';
      } else {
        if (this.isPremium && this.membership.next) {
          return (this.isTrialPremium)
            ? '$ 00.00'
            : `$ ${ Number(this.membership.next.price.amount).toFixed(2) }/${ this.membershipTimeRevenue }`;
        } else {
          return false;
        }
      }
    },
    membershipWarranty: function() {
      if (this.isPremium && this.membership.warranty_date) {
        const expiredDate = new Date(this.membership.warranty_date.date_full);
        const currentDate = new Date();

        if (expiredDate > currentDate) {
          const diffTime = Math.abs(expiredDate - currentDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          return (diffDays > 5)
            ? `Tu garantía termina el <span class="w-bold">${ this.membership.warranty_date.date }</span>`
            : `Tu garantía termina en <span class="w-bold">${ diffDays } ${ (diffDays == 1) ? 'día' : 'días' }</span>`;
        } else {
          return `Tu garantía venció el <span class="w-bold">${ this.membership.warranty_date.date }</span>`;
        }
      } else {
        return false;
      }
    },
    isMembershipWarranty: function () {
      if (this.isPremium && this.membership.warranty_date) {
        const expiredDate = new Date(this.membership.warranty_date.date_full);
        const currentDate = new Date();

        return (expiredDate > currentDate) ? true : false;
      } else {
        return false;
      }
    },

    userCanRenew: function() {
      return (this.isPremium && !this.membership.next && this.membership.remaining_days <= 6) ? true : false;
    },
    userCanDeleteCards: function() {
      if (this.membership.next) {
        return (this.paymentMethods.length > 1) ? true : false;
      } else {
        return true;
      }
    },

    hasSubscriptionProvider() {
      return this.membership.provider ?? false;
    },
  },
  watch: {
    userData(data) {
      this.user = data;

      if (this.user && this.user.id) {
        if (this.isPremium) this.getSuscriptionDetails();

        this.getPaymentMethods();
      }
    },
    'cancel.description.value': function() {
      this.cancel.description.isValid = (this.cancel.description.value.length >= 5) ? true : false;
    },
  },
  mounted() {
    this.user = this.userData;

    if (this.user && this.user.id) {
      if (this.isPremium) this.getSuscriptionDetails();

      this.getPaymentMethods();
    }
  },
  methods: {
    initTooltips: function() {
      window.setTimeout(()=>{
        tippy('.c-tooltip-toggle', {
          content(reference) {
            return `
            <div class="c-tooltip c-tooltip--tiny p-2">
              Recuerda que las membresias son autorrenovables. Si tienes alguna consulta, escribenos a <span class="w-bold">hola@arcux.net</span>
            </div>`;
          },
          allowHTML: true,
          theme: 'arcux-dark',
          animation: 'scale',
          inertia: true,
          hideOnClick: true,
          trigger: 'click',
        });
      }, 2000)
    },

    isWrongField: function(field) {
      return this.cancel.try && !this.cancel[field].isValid;
    },
    getMethodLogo: function(method) {
      method = method.toLowerCase();

      const brand = (['visa', 'mastercard', 'amex', 'diners', 'paypal'].includes(method))
        ? (method == 'visa') ? `${ method }.svg` : `${ method }.png`
        : 'general.svg';

      return `${arcux.site}/app/themes/arcuxt/dist/images/icons/payments/${ brand }`;
    },
    getMethodSummary: function(method) {
      if (method.brand != 'paypal') {
        return `XXXX XXXX XXXX ${ method.last_four }`;
      }
    },

    openPaymentMethodDialog: function(method) {
      this.method.selected = method;
      this.paymentMethodDialog.switcher = true;
    },

    getSuscriptionDetails: function() {
      const url = `${window.arcux.site}/api/v1/users/${this.userData.id}/profile/subscription/`;

      this.isLoadingMembership = true;

      fetch(url , {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(response => {
        if (response.status){
          this.membership = response.data;

          const expiredDate = new Date(this.membership.expired_date.date_full);
          const currentDate = new Date(this.membership.current_day);

          const diffTime = Math.abs(expiredDate - currentDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          this.membership.remaining_days = diffDays;

          this.paymentMethodDialog.body = (!this.userCanDeleteCards)
            ? 'Para eliminar un método de pago primero debes cancelar tu membresía.'
            : '¿Estás seguro de eliminar este método de pago?';

          this.initTooltips();
        }
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        this.isLoadingMembership = false;
      })
    },
    getPaymentMethods: function() {
      this.isLoadingPaymentMethods = true;

      const request = `${window.arcux.site}/api/v1/users/${this.userData.id}/profile/payment-methods/`;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(response => {
        if (response.status){
          this.paymentMethods           = response.payment_methods;
          this.paymentMethodDialog.body = '¿Estás seguro de eliminar este método de pago?';
        }

        this.isLoadingPaymentMethods = false;
      })
      .catch(err => {
        this.isLoadingPaymentMethods = false;

        throw err;
      })
    },

    deleteSubscriptionHandler: function() {
      this.cancel.try = true;

      const isValidReason = (this.cancel.reason == 'other') ? this.cancel.description.isValid : true;

      if (isValidReason) {
        this.cancel.isLoading = true;

        let request = '';

        if (this.hasSubscriptionProvider) {
          request = (this.hasSubscriptionProvider === 'stripe')
            ? `${ process.env.VUE_APP_API_V2 }/users/${ this.userData.id }/profile/subscriptions`
            : `${ window.arcux.site }/api/v1/users/${ this.userData.id }/profile/subscription/hotmart/cancel`;
        } else {
          request = `${ window.arcux.site }/api/v1/users/${ this.userData.id }/profile/subscription/cancel`;
        }

        const formData  = new FormData();

        if (this.cancel.reason) {
          formData.append('note', (this.cancel.reason == 'other') ? this.cancel.description.value : this.cancel.reason);
        }

        if (this.hasSubscriptionProvider && this.hasSubscriptionProvider === 'stripe') {
          fetch(request, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...(this.cancel.reason && { notes: (this.cancel.reason == 'other') ? this.cancel.description.value : this.cancel.reason }),
            }),
          })
          .then(res => {
            if (res.status == 201 || res.status < 300) {
              return res.json();
            } else {
              throw res;
            }
          })
          .then(response => {
            if (response.status) {
              window.location.reload();
            }
          })
          .catch(err => {
            window.setTimeout(() => {
              this.cancel.isLoading = false;
            }, 1000);

            throw err;
          })
        } else {
          fetch(request, {
            method: 'POST',
            body: formData,
            headers: {
              Authorization: `Bearer ${window.arcux.token}`,
            },
          })
          .then(res => {
            if (res.status == 201 || res.status < 300) {
              return res.json();
            } else {
              throw res;
            }
          })
          .then(response => {
            if (response.status) {
              window.location.reload();
            }
          })
          .catch(err => {
            window.setTimeout(() => {
              this.cancel.isLoading = false;
            }, 1000);

            throw err;
          })
        }
      }
    },
    deletePaymentMethodHandler: function() {
      if (this.method.selected) {
        this.method.isDeletingPaymentMethod = true;

        const request   = `${window.arcux.site}/api/v1/users/${this.userData.id}/profile/payment-methods/remove`;
        const formData  = new FormData();

        formData.append('payment_method', this.method.selected.id);

        fetch(request, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${window.arcux.token}`,
          },
        })
        .then(res => {
          if (res.status == 201 || res.status < 300) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then(response => {
          if (response.status){
            this.paymentMethodDialog.switcher = false;
            this.paymentMethods = this.paymentMethods.filter(pm => pm != this.method.selected);
          }

          this.method.isDeletingPaymentMethod = false;
        })
        .catch(err => {
          this.method.isDeletingPaymentMethod = false;

          throw err;
        })
      }
    },
  },
}
</script>
